<h2>Promo</h2>

<form  [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field id="code">
        <input matInput
               required
               placeholder="Code"
               (input)="codeChanged()"
               formControlName="code">
        <mat-error>{{fields.code.errors}}</mat-error>
    </mat-form-field>

    <div class="label">Type</div>
    <mat-radio-group formControlName="type" id="type_group">
        <mat-radio-button value="percent_off">Percent Off</mat-radio-button>
        <mat-radio-button value="amount_off">Amount Off</mat-radio-button>
    </mat-radio-group>

    <div>
        <mat-form-field id="discount">
            <input matInput
                   required
                   placeholder="Discount"
                   formControlName="discount">
        </mat-form-field>
        <span *ngIf="!isPercent()">$</span>
        <span *ngIf="isPercent()">%</span>
    </div>

    <div>
        <div class="label" id="limited_label">Limited</div>
        <mat-checkbox formControlName="limited"></mat-checkbox>
        <mat-form-field id="init_inv_field" [ngClass]="{hidden: !isLimited()}">
            <input matInput
                   placeholder="Initial Inventory"
                   type="number"
                   min="0"
                   formControlName="initialInventory">
        </mat-form-field>
    </div>

    <div>
        <div class="label" id="exp_label">Expires</div>
        <mat-checkbox formControlName="expFlag"></mat-checkbox>
        <span id="exp_fields" [ngClass]="{hidden: !expires()}">
            <mat-form-field id="picker_field">
                <input matInput
                       [matDatepicker]="picker"
                       [min]="'2019-12-09'"
                       formControlName="expDate"
                       placeholder="Exp. Date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            at
            <mat-form-field id="hour_field">
                <input matInput
                       type="number"
                       min="1"
                       max="12"
                       formControlName="expHour">
            </mat-form-field>
            :
            <mat-form-field id="minute_field">
                <input matInput
                       type="number"
                       min="0"
                       max="59"
                       formControlName="expMinute">
            </mat-form-field>

            <mat-radio-group formControlName="expAmPm">
                <mat-radio-button value="am">AM</mat-radio-button>
                <mat-radio-button value="pm">PM</mat-radio-button>
            </mat-radio-group>
        </span>
    </div>

    <div>
        <div class="label">Disabled</div>
        <mat-checkbox formControlName="disabled"></mat-checkbox>
    </div>

    <div id="button_row">
        <button mat-raised-button
                type="submit"
                color="primary"
                class="medium_button"
                [disabled]="!form.valid || submitting || form.pristine">Save</button>

        <button mat-raised-button
                type="button"
                color="accent"
                class="medium_button"
                (click)="cancel()"
                [disabled]="submitting">Cancel</button>

        <mat-spinner *ngIf="submitting" diameter="30"></mat-spinner>
    </div>

</form>
